"use strict";

import {
    default as React,
    Component,
} from 'react';
import PropTypes from 'prop-types';

import * as D3Shape from 'd3-shape';
import CommonProps from '../commonProps';
import {series} from '../utils/series';

export default class Line extends Component {
    constructor (props) {
        super(props);
    }

    static defaultProps = {
        interpolate: null,
        ...CommonProps
    };

    _mkLine(dom) {
        const {
            lineClassName
        } = this.props;


        let dataset = series(this.props);

        let that = this;

        return (
            <g>
                {
                    dataset.map((line, i) => {

                        return (
                            <path
                                stroke={line.color}
                                fill="none"
                                className={`${line.className} line`}
                                d={that._setAxes(line.data)}
                                style={line.customStyle}
                                key={i}
                            />
                        )
                    })
                }
            </g>
        )
    }

    _setAxes (data) {
        const {
            xScaleSet,
            yScaleSet
        } = this.props;

        let line =  D3Shape.line()
            .defined(function(d) { return d.y; })
            .x((d) => {  return xScaleSet(d.x) })
            .y((d) => {  return yScaleSet(d.y) })

        return line.call(this, data);
    }

    render() {
        let line = this._mkLine();

        return (
            <g>
                {line}
            </g>
        );
    }
}
